// import SectionList from "./SectionList.js";
// import SectionItem from "./SectionItem.js";

import jquery from "jquery";
import React, { Component } from "react";

class SectionItem extends Component {
  constructor(props) {
    super(props);
    // this.myRef = React.createRef();
  }

  componentDidMount() {
    // window.instgrm.Embeds.process();
    jquery(this.refs.item).html(this.props.item.html);
    // jquery(this.myRef).html(this.props.item.html);
  }

  render() {
    return (
      <div
        ref="item"
        className={this.props.itemClassName}
        key={this.props.item.id}
      >
        Loading...
      </div>
    );
  }
}

export default SectionItem;
